var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"firmware-status-mini"},[_vm._v(" fv"+_vm._s(_vm.formattedCurrentVersion)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }